var _interface = require('util/interface').interface;

/**
 * Delta that represents the difference between two binary values.
 *
 * @class diffusion.datatypes.BinaryDelta
 * @since 5.7
 */
module.exports = _interface('BinaryDelta', [
    /**
     * Whether this delta contains any changes.
     *
     * @returns {Boolean} if the delta contains changes
     * @function diffusion.datatypes.BinaryDelta#hasChanges
     */
    'hasChanges'
]);



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/data/binary/binary-delta.js
// module id = 960
// module chunks = 1